import { Injectable, Provider } from "@angular/core";
import { Observable } from "rxjs";
import {
  OfferPreviewCancelCommand,
  OfferPreviewCancelCommandResult,
  OfferPreviewCheckoutCommand, OfferPreviewCheckoutCommandResult, OfferPreviewClient,
  OfferPreviewGetQuery, OfferPreviewGetQueryResult
} from "../../INTEGRA_Shop_Client";
import { IOfferPreviewApiService, IOfferPreviewApiServiceToken } from "./offer-preview-api-service.interface";

@Injectable({
  providedIn: 'root'
})
export class OfferPreviewApiService implements IOfferPreviewApiService {

  constructor(
    private offerPreviewClient: OfferPreviewClient,
  ) { }

  public offerPreviewGet(
    cartNumber: number,
    validateCart: boolean | undefined = true
  ): Observable<OfferPreviewGetQueryResult> {
    let query = new OfferPreviewGetQuery({
      cartNumber: cartNumber,
      validateCart: validateCart
    });
    return this.offerPreviewClient.offerPreviewGet(query);
  }

  public offerPreviewCheckout(cartNumber: number): Observable<OfferPreviewCheckoutCommandResult> {
    let command = new OfferPreviewCheckoutCommand({
      cartNumber: cartNumber,
    });
    return this.offerPreviewClient.offerPreviewCheckout(command);
  }

  public offerPreviewCancel(shoppingCartNumber: number): Observable<OfferPreviewCancelCommandResult> {
    let command = new OfferPreviewCancelCommand({
      shoppingCartNumber: shoppingCartNumber
    });
    return this.offerPreviewClient.offerPreviewCancel(command);
  }

}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const OfferPreviewApiServiceProvider: Provider[] = [
  { provide: OfferPreviewClient },
  { provide: IOfferPreviewApiServiceToken, useExisting: OfferPreviewApiService }
];
